/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @enum {string}
 */

export const CategoryType = {
  ItemTab: "ITEM_TAB",
  Item: "ITEM",
  Discount: "DISCOUNT",
  Shared: "SHARED",
} as const;

export type CategoryType = (typeof CategoryType)[keyof typeof CategoryType];

export type CategoryTypeEnumType = typeof CategoryType;
export type CategoryTypeOptional = CategoryType;
export type CategoryTypeTrackedI = CategoryType;
export type CategoryTypeTracked = CategoryType;
export type CategoryTypeMetaI = EnumMetaType<
  CategoryTypeEnumType,
  CategoryType
>;
export const CategoryTypeMeta = typeMetaEnum<
  CategoryTypeEnumType,
  CategoryType
>("CategoryType", CategoryType);
export function transformDatesCategoryType(model: CategoryType) {}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
